<script>
import Layout from '@layout/main'
import ListCourse from '@components/List/Course'
import { brandOptions, cityOptions, eventOptions, eventTypeOptions } from '@utils/zerone-options'
import { getDefaultBrand, getDefaultCity, getDefaultMonth, getDefaultEvent, getDefaultEventType } from '@utils/zerone-get-default'
import monthToDate from '@utils/format-mouth-to-date'
import setWindowHistory from '@utils/window-history'

const DEFAULT_SEARCH = {
  category: '',
  type: '',
  month: '',
  city: '',
  brand: '',
}

export default {
  page() {
    return {
      title: `課程活動`,
    }
  },
  components: {
    Layout,
    ListCourse,
  },
  props: {
    brandOptions: {
      type: Array,
      default: () => {
        return []
      },
    },
    cityOptions: {
      type: Array,
      default: () => {
        return []
      },
    },
  },
  data() {
    return {
      courseList: [],
      courseListPagination: {},
      searchData: {
        category: getDefaultEvent(this.$route.query.category) || DEFAULT_SEARCH.category,
        type: getDefaultEventType(this.$route.query.type) || DEFAULT_SEARCH.type,
        month: getDefaultMonth(this.$route.query.month) || DEFAULT_SEARCH.month,
        city: getDefaultCity(this.$route.query.city, this.cityOptions) || DEFAULT_SEARCH.city,
        brand: getDefaultBrand(this.$route.params.brandAlias || this.$route.query.brand, this.brandOptions) || DEFAULT_SEARCH.brand,
      },
      searchList: [
        {
          width: '14%',
          type: 'select',
          placeholder: '課程/活動',
          name: 'category',
          clearable: false,
          options: eventOptions(),
        },
        {
          width: '14%',
          type: 'select',
          placeholder: '實體/線上',
          name: 'type',
          clearable: true,
          options: eventTypeOptions(),
        },
        {
          width: '16%',
          type: 'month',
          placeholder: '不限時間',
          name: 'month',
          clearable: true,
          valueFormat: 'yyyy-MM',
        },
        {
          width: '13%',
          type: 'select',
          placeholder: '選擇縣市',
          name: 'city',
          clearable: true,
          options: cityOptions(this.cityOptions),
        },
        {
          width: '30%',
          type: 'select',
          placeholder: '品牌篩選',
          name: 'brand',
          clearable: true,
          options: brandOptions(this.brandOptions),
        },
      ],
      loadingFetchEventList: false,
      isShowFilterMenu: false,
    }
  },
  created() {
    this.tryToFetchEventList()
  },
  methods: {
    onSubmit() {
      setWindowHistory({
        query: {
          // ...this.$route.query,
          page: 1,
        },
      })
      this.tryToFetchEventList({
        storeParams: {
          // ...this.$route.params,
          page: 1,
        },
      })
    },
    onChangePagination(page) {
      this.tryToFetchEventList({
        storeParams: {
          // ...this.$route.params,
          page,
        },
      }).then(() => {
        const url = new URL(window.location)
        let params = url.searchParams
        if (params.has('page')) {
          this.$scrollToElement({
            $el: this.$refs['sectionList'],
            offset: 270,
          })
        }
      })
    },
    async tryToFetchEventList({ storeParams } = {}) {
      this.loadingFetchEventList = true

      this.$store
        .dispatch('event/fetchEventList', {
          ...this.searchData,
          ...monthToDate(this.searchData.month),
          eventCategoryAlias: this.searchData.category,
          brandAlias: this.searchData.brand,
          page: this.$route.query.page,
          limit: 9,
          ...storeParams,
        })
        .then((response) => {
          this.courseList = response.items
          this.courseListPagination = response.pagination
        })
        .finally(() => {
          this.loadingFetchEventList = false
        })
    },
    onClearSearch() {
      Object.keys(this.searchData).forEach((key) => {
        this.searchData[key] = undefined
      })
      setWindowHistory({
        query: {
          ...this.$route.query,
          ...this.searchData,
          page: 1,
        },
      })
      this.tryToFetchEventList({
        storeParams: {
          page: 1,
        },
      })
    },
    onOpenFilter(status) {
      this.isShowFilterMenu = status
    },
  },
}
</script>
<template>
  <Layout>
    <BaseBanner title="課程活動" :image="require('@assets/images/course/index_banner.png')" custom-class="isStyleWhite" @openFilter="onOpenFilter(!isShowFilterMenu)" />
    <section :class="$style.sectionCourseList" class="section">
      <div class="container">
        <BaseSearchBar v-model="searchData" :list="searchList" submit-text="搜尋課程" :is-show-filter="isShowFilterMenu" @search="onSubmit" @openFilter="onOpenFilter(false)" />
        <BasePre>{{ searchData }}</BasePre>
        <div ref="sectionList" v-loading="loadingFetchEventList">
          <template v-if="!!courseList.length">
            <ListCourse :course-list="courseList" type="grid" />
            <BasePagination2 :pagination="courseListPagination" @change="onChangePagination" />
          </template>
          <BaseNull v-else is-search-null @clearSearch="onClearSearch" />
        </div>
        <BasePre>{{ courseList }}</BasePre>
      </div>
    </section>
  </Layout>
</template>
<style lang="scss" module>
.sectionCourseList {
  :global {
    .sectionCourseList {
    }
  }
}
</style>
